var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.items.length)?_c('tr',[_c('td',{attrs:{"colspan":_vm.headers.length}},[_vm._m(0)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-available"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"middle"},[_c('div',{staticClass:"inner"},[_vm._v(" No data available ")])])])])
}]

export { render, staticRenderFns }